import React from "react";
import "../Css/Hero.css";
import heroImg from "../assets/banner_2.png";
// import HowItWorks from "./HowItWorks";   
import OurExpertise from "./OurExpertise";   // 👈 IMPORT
import WhyChooseUs from "./WhyChooseUs";   // 👈 IMPORT
// import OurExperience from "./OurExperience";   // 👈 IMPORT
import OurStarStudents from "./OurStarStudents";   // 👈 IMPORT
import OurTeachers from "./OurTeachers";   // 👈 IMPORT
import AboutCTA from "./AboutCTA";   // 👈 IMPORT
import Testimonials from "./Testimonials";   // 👈 IMPORT
import VideoSection from "./VideoSection";   // 👈 IMPORT
import StudentReview from "./StudentReview";   // 👈 IMPORT

const Hero = () => {
  return (
    <>
      <section className="hero">
        {/* background */}
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="green-bg"></div>

        <div className="hero-container">
          {/* LEFT */}
          <div className="hero-left">
            <h1><span>IIT-JEE</span> | <span>NEET</span> | <span>BITSAT </span> | <span>Olympiads</span> Coaching in Vadodara</h1>

            <p className="subtitle">
  Prepare for JEE Main, JEE Advanced, NEET, BITSAT and Olympiad exams with experienced faculty, structured learning, regular test series and personalized doubt-solving support in Vadodara.
</p>


            <ul className="features">
              <li>Experienced & Dedicated Faculty</li>
              <li>Structured Curriculum & Regular Tests</li>
              <li>Personal Attention & Doubt Solving</li>
              <li>Flexible Timings as per Student Needs</li>
              <li>Exam-Oriented Preparation Strategy</li>
            </ul>

            <div className="hero-buttons">
              <a
                href="https://wa.me/918849189845?text=Hello%20I%20want%20to%20book%20tuition"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Enquire Now
              </a>

              <a href="tel:+918849189845" className="btn-outline">
                Call : +91 8849189845
              </a>
            </div>
          </div>

          {/* RIGHT */}
          {/* RIGHT */}
          <div className="hero-right">
            <div className="image-card">
              <img src={heroImg} alt="Home Tuition" />
            </div>
          </div>
 
        </div>
      </section>

      {/* 👇 HOW IT WORKS SECTION */}
      <VideoSection />
      <OurExpertise />
      <WhyChooseUs />
      {/* <OurExperience /> */}
      <OurStarStudents />
      <OurTeachers />
      <AboutCTA />
      <StudentReview />
      <Testimonials />
    </>
  );
};

export default Hero;
